import { useEffect, useState } from "react";
import emitter from "@webcore/core/events/eventemitter";
import { AppPermissionStatus } from "@webcore/core/permissions/permissions.status";
import { Events } from "@webcore/core/events/Events";

function useXRErrors() {
  const [xrPermissionStatus, setXRPermissionStatus] =
    useState<AppPermissionStatus | null>(null);
  const [xrSupportStatus, setXRSupportStatus] = useState<boolean | null>(null);
  const [xrOtherStatus, setXROtherStatus] = useState<boolean | null>(null);

  useEffect(() => {
    const handlePermissionDenied = (
      event: Events["xr-error-permission-denied"]
    ) => {
      if (event && event.type) {
        if (event.type === "camera") {
          setXRPermissionStatus(AppPermissionStatus.DENIED_CAMERA);
        } else if (event.type === "motion") {
          setXRPermissionStatus(AppPermissionStatus.DENIED_MOTION);
        }
      } else {
        setXRPermissionStatus(AppPermissionStatus.DENIED);
      }
    };

    const handleXRUndefined = () => {
      setXROtherStatus(false);
    };

    const handleXRNotSupported = () => {
      setXRSupportStatus(false);
    };

    const handleXRStarted = () => {
      setXRPermissionStatus(AppPermissionStatus.GRANTED);
      setXRSupportStatus(true);
      setXROtherStatus(true);
    };

    emitter.on("xr-error-permission-denied", handlePermissionDenied);
    emitter.on("xr-error-undefined", handleXRUndefined);
    emitter.on("xr-error-not-supported", handleXRNotSupported);
    emitter.on("xr-started", handleXRStarted);

    return () => {
      emitter.off("xr-error-permission-denied", handlePermissionDenied);
      emitter.off("xr-error-undefined", handleXRUndefined);
      emitter.off("xr-error-not-supported", handleXRNotSupported);
      emitter.off("xr-started", handleXRStarted);
    };
  }, []);

  return {
    xrPermissionStatus,
    xrSupportStatus,
    xrOtherStatus,
  };
}

export default useXRErrors;
